import { usePreviousProp } from '@infl-ts/util-hooks';
import { ChallengePlayerProvider } from '@infl-ts/util-use-challenge-player';
import { useRef } from 'react';
import { useLocation } from 'react-router';
import { ChallengeBarWrapper } from './challenge-bar-wrapper';
import ChallengeDataWrapper from './challenge-data-wrapper';
import ChallengePlayerDrawer, { ChallengePlayerContent } from './challenge-player';
import { PreviewPlayer } from './challenge-player-preview/preview-player';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var GlobalChallengePlayer = function GlobalChallengePlayer(_ref) {
  var _children = _ref.children;
  var drawerPaperRef = useRef(null);
  var location = useLocation();
  var prevLocation = usePreviousProp(location);
  return /*#__PURE__*/_jsx(ChallengePlayerProvider, {
    "data-element": "ChallengePlayerProvider",
    "data-component": "GlobalChallengePlayer",
    "data-source-file": "global-challenge-player.tsx",
    children: function children(_ref2) {
      var _challengePlayerState, _challengePlayerState2, _challengePlayerState3;

      var challengePlayerState = _ref2.challengePlayerState,
          startNewActivity = _ref2.startNewActivity,
          continueActivity = _ref2.continueActivity,
          closeActivity = _ref2.closeActivity;
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(ChallengePlayerDrawer, {
          drawerPaperRef: drawerPaperRef,
          open: challengePlayerState.open,
          challengeConfig: challengePlayerState.challengeConfig,
          children: (_challengePlayerState = challengePlayerState.challengeConfig) !== null && _challengePlayerState !== void 0 && _challengePlayerState.isPreview ? /*#__PURE__*/_jsx(PreviewPlayer, {
            skippableOnboarding: challengePlayerState.challengeConfig.canClose && challengePlayerState.challengeConfig.onboarding
          }) : ((_challengePlayerState2 = challengePlayerState.challengeConfig) === null || _challengePlayerState2 === void 0 ? void 0 : _challengePlayerState2.uuid) && /*#__PURE__*/_jsx(ChallengeDataWrapper, {
            challengeId: challengePlayerState.challengeConfig.uuid,
            closeActivity: closeActivity,
            activity: (_challengePlayerState3 = challengePlayerState.challengeConfig) === null || _challengePlayerState3 === void 0 ? void 0 : _challengePlayerState3.activity,
            startNewActivity: startNewActivity,
            continueActivity: continueActivity,
            prevLocation: prevLocation,
            children: function children(challengeData) {
              var _challengePlayerState4;

              return (_challengePlayerState4 = challengePlayerState.challengeConfig) !== null && _challengePlayerState4 !== void 0 && _challengePlayerState4.minimized ? /*#__PURE__*/_jsx(ChallengeBarWrapper, {
                challengeData: challengeData
              }) : /*#__PURE__*/_jsx(ChallengePlayerContent, {
                challengeData: challengeData,
                scrollToChallengeTop: function scrollToChallengeTop() {
                  var _drawerPaperRef$curre;

                  return drawerPaperRef === null || drawerPaperRef === void 0 ? void 0 : (_drawerPaperRef$curre = drawerPaperRef.current) === null || _drawerPaperRef$curre === void 0 ? void 0 : _drawerPaperRef$curre.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                  });
                }
              });
            }
          })
        }), _children]
      });
    }
  });
};